import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { TrainersStudentModel } from "common/models/page-models/Trainer Student/trainers-student-data.model";

 
@Injectable()
export class CategoryListDataService extends DataService<TrainersStudentModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getCatList,http);
    }
 
 
//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
   
    createInstance(): TrainersStudentModel {
        return new TrainersStudentModel();
    }

 
    
 
}